<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="12">
                    <h1 class="headline font-weight-light mb-3">
                        <span class="red--text">{{ data_main.message }}</span
                        ><br />
                        <!-- รายละเอียดปิดงานในระบบ <b> iSmart</b> -->
                    </h1>
                </v-col>
            </v-row>
            <v-row>
                <!-- <v-col cols="12">
                    <b class="red--text">{{ data_main.message }}</b>
                </v-col> -->
                <v-col cols="12" class="mar-t-15">
                    <span class="text-i-2 mr-1">{{ data_main.case_title }}</span
                    ><br />
                    <span class="text-i-1 mr-1">Case ID :</span>
                    <span class="text-i-2 mr-2">{{ data_main.case_id }}</span>
                    <v-tooltip
                        v-if="data_main.status == 'close'"
                        top
                        class="ml-1"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                x-small
                                v-on="on"
                                fab
                                @click="doCopyLog(data_main.case_id)"
                            >
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </template>
                        <span>Copy {{ data_main.case_id }}</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" class="mar-t-15">
                    <span class="text-i-1 mr-1">WO Number :</span>
                    <span class="text-i-2 mr-2">{{ data_main.wonumber }}</span>
                    <v-tooltip
                        v-if="data_main.status == 'close'"
                        top
                        class="ml-1"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                x-small
                                v-on="on"
                                fab
                                @click="doCopyLog(data_main.wonumber)"
                            >
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                        </template>
                        <span>Copy {{ data_main.wonumber }}</span>
                    </v-tooltip>
                </v-col>

                <v-col cols="12" class="mar-t-15" v-if="data_main.cdax_open">
                    <span class="text-i-1 mr-1">วันที่เปิดงาน CDAX :</span>
                    <span class="text-i-2 mr-2">{{ data_main.cdax_open }}</span>
                </v-col>

                <v-col cols="12" class="mar-t-15" v-if="data_main.onsite_at">
                    <span class="text-i-1 mr-1">วันที่ Onsite :</span>
                    <span class="text-i-2 mr-2">{{ data_main.onsite_at }}</span>
                </v-col>

                <v-col cols="12" class="mar-t-15" v-if="data_main.ce_symptom">
                    <span class="text-i-1 mr-1">อาการเสียที่พบ :</span>
                    <span class="text-i-2 mr-2">
                        {{ data_main.ce_symptom }}
                        <v-tooltip top class="ml-1">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    x-small
                                    v-on="on"
                                    fab
                                    @click="doCopyLog(data_main.ce_symptom)"
                                >
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                            </template>
                            <span>Copy {{ data_main.ce_symptom }}</span>
                        </v-tooltip>
                    </span>
                </v-col>

                <v-col cols="12" class="mar-t-15" v-if="data_main.solution">
                    <span class="text-i-1 mr-1">Solution :</span> <br />
                    <span class="text-i-2 mr-2">
                        {{ data_main.solution }}
                        <v-tooltip top class="ml-1">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    x-small
                                    v-on="on"
                                    fab
                                    @click="doCopyLog(data_main.solution)"
                                >
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                            </template>
                            <span>Copy {{ data_main.solution }}</span>
                        </v-tooltip>
                    </span>
                </v-col>

                <v-col
                    cols="12"
                    class="mar-t-15"
                    v-if="data_main.parts.length > 0"
                >
                    <span class="text-i-1">Parts</span> <br />
                    <div v-for="(r, i) in data_main.parts" :key="i">
                        <span class="text-i-2 mr-2">
                            <v-chip small class="mr-1 primary--text">
                                {{ i + 1 }}.
                            </v-chip>

                            {{ r.ponumber + " | " + r.part_name }}
                            <br />

                            <v-tooltip top class="ml-1">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        x-small
                                        v-on="on"
                                        fab
                                        @click="doCopyLog('P/N/' + r.part_name)"
                                    >
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Copy {{ r.ct_new }}</span>
                            </v-tooltip>
                            <br />
                            {{ r.part_description }} <br />
                            {{ "วันที่ Part Ship : " + r.ship_date_x }}
                            <br />

                            <div v-if="r.ce_status == 'DOA'">
                                <span class="red--text">
                                    Usage Code : SAUS-Used + Not Consumed
                                </span>
                                <br />
                                <span class="red--text">
                                    Failure Code : 55 - DOA
                                </span>
                            </div>

                            <div v-if="r.ce_status == 'Bad'">
                                <span class="red--text">
                                    Usage Code : SAUS-Used + Consumed
                                </span>
                                <br />
                                <span class="red--text">
                                    Failure Code : 73 - Used & Consumed
                                </span>
                            </div>

                            <div v-if="r.ce_status == 'Good'">
                                <span class="red--text">
                                    Usage Code : SAUN-Unused
                                </span>
                                <br />
                                <span class="red--text">
                                    Failure Code : 72 - Returned good
                                </span>
                            </div>
                            <br />
                            <span
                                class="text-i-1 mr-1"
                                v-if="data_main.status == 'close' && r.ct_old"
                            >
                                CT เก่า :
                            </span>
                            <span
                                class="text-i-2 mr-2"
                                v-if="data_main.status == 'close' && r.ct_old"
                            >
                                {{ r.ct_old }}
                            </span>
                            <v-tooltip
                                v-if="data_main.status == 'close' && r.ct_old"
                                top
                                class="ml-1"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        x-small
                                        v-on="on"
                                        fab
                                        @click="doCopyLog('OLD CT#' + r.ct_old)"
                                    >
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Copy {{ "OLD CT#" + r.ct_old }}</span>
                            </v-tooltip>
                            <br />
                            <span
                                class="text-i-1 mr-1 mar-t-15"
                                v-if="data_main.status == 'close' && r.ct_new"
                            >
                                CT ใหม่ :
                            </span>
                            <span
                                class="text-i-2 mr-2"
                                v-if="data_main.status == 'close' && r.ct_new"
                            >
                                {{ r.ct_new }}
                            </span>
                            <v-tooltip
                                v-if="data_main.status == 'close' && r.ct_new"
                                top
                                class="ml-1"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        x-small
                                        v-on="on"
                                        fab
                                        @click="doCopyLog('NEW CT#' + r.ct_new)"
                                    >
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Copy {{ "NEW CT#" + r.ct_ne }}</span>
                            </v-tooltip>
                        </span>
                        <br />
                    </div>
                </v-col>

                <v-col cols="12" class="mar-t-15" v-if="data_main.fid_text">
                    <span class="text-i-1 mr-1">FID Text :</span>
                    <span class="text-i-2 mr-2">
                        {{ data_main.fid_text }}
                        <v-tooltip top class="ml-1">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    x-small
                                    v-on="on"
                                    fab
                                    @click="
                                        doCopyLog('@FID:' + data_main.fid_text)
                                    "
                                >
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                            </template>
                            <span>Copy {{ data_main.fid_text }}</span>
                        </v-tooltip>
                    </span>
                </v-col>

                <v-col cols="12" class="mar-t-15" v-if="data_main.printcount">
                    <span class="text-i-1 mr-1">Print count :</span>
                    <span class="text-i-2 mr-2">
                        {{ data_main.printcount }}
                        <v-tooltip top class="ml-1">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    x-small
                                    v-on="on"
                                    fab
                                    @click="
                                        doCopyLog('@P:' + data_main.printcount)
                                    "
                                >
                                    <v-icon>mdi-content-copy</v-icon>
                                </v-btn>
                            </template>
                            <span>Copy {{ data_main.printcount }}</span>
                        </v-tooltip>
                    </span>
                </v-col>

                <v-col cols="12" class="mar-t-15" v-if="data_main.delay_code">
                    <span class="text-i-1 mr-1 red--text font-b">
                        ให้ไส่ Delay Code เป็น :
                    </span>
                    <span class="text-i-2 mr-2 red--text font-b">
                        {{ data_main.delay_code }}
                    </span>
                </v-col>

                <v-col
                    cols="12"
                    v-if="data_main.status == 'close'"
                    class="mar-t-10"
                >
                    <span class="text-i-1 mr-1">Closing Summary</span><br />
                    <v-textarea
                        :disabled="data_main.disabled == 'Y'"
                        outlined
                        v-model="data_main.closetext"
                        class="mt-3"
                        label="Closing Summary ..."
                        rows="4"
                    ></v-textarea>

                    <v-row>
                        <v-col cols="12" md="4" class="mar-t-15">
                            <v-tooltip top class="ml-1">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        v-on="on"
                                        block
                                        @click="doCopyLog(data_main.closetext)"
                                        class="primary--text"
                                    >
                                        Copy Closing Summary
                                    </v-btn>
                                </template>
                                <span>Copy {{ data_main.closetext }}</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="12" md="4" class="mar-t-15">
                            <v-btn
                                block
                                color="success"
                                @click="save()"
                                :disabled="
                                    data_main.closetext == null ||
                                        data_main.closetext == '' ||
                                        data_main.closetext == undefined
                                "
                            >
                                Save Closing Summary
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- <v-col
                    cols="12"
                    md="4"
                    class="mar-t-15"
                    v-if="data_main.status != 'close' && check_page != 2"
                >
                    <v-btn block class="primary--text" @click="close()"
                        >Close ISmart</v-btn
                    >
                </v-col>
                <v-col cols="12" v-if="data_main.status == 'close'">
                    <span class="text-i-1 mr-1">
                        ตัวอย่างการปิดงานบนระบบ ISmart
                    </span>
                    <br />
                    <img
                        class="img-i-1 mt-2"
                        src="../../../assets/all/messageImage_1630570355540.jpg"
                    />
                </v-col> -->
            </v-row>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"
let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    props: ["data_ismart", "check_page"],
    watch: {
        data_ismart: function(newQuestion, oldQuestion) {
            this.get_data(newQuestion)
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    methods: {
        async get_data(dd) {
            this.subcase_id = dd === undefined ? this.data_ismart : dd
            if (this.subcase_id != "") {
                await axios
                    .get(url + "engineer/ismart/" + this.subcase_id, this.tk)
                    .then((response) => {
                         console.log("response",response.data)
                        this.data_main = response.data
                        if(response.data.message == "เคสนี้ช่างยังไม่ต้องทำอะไรในระบบ iSmart"){
                            this.$emit("close_page")
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        async save() {
            let send = {
                subcase_id: this.subcase_id,
                closetext: this.data_main.closetext,
            }
            await axios
                .post(url + "engineer/ismart/", send, this.tk)
                .then((response) => {

                    this.$emit("close_page")
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        close() {
            this.$emit("close_page")
        },
        doCopyLog: function(textId) {
            this.text_copy = textId
            navigator.clipboard.writeText(this.text_copy)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
    },
    data() {
        return {
            tk: null,
            data_main: [],
            subcase_id: "",
        }
    },
}
</script>
<style scoped>
.text-i-1 {
    color: rgb(39, 50, 70);
    font-size: 16px;
    font-weight: bold;
}
.text-i-2 {
    color: rgb(57, 94, 167);
    font-size: 16px;
    font-weight: bold;
}
.img-i-1 {
    width: 100%;
}
</style>
